import { render, staticRenderFns } from "./FlickingSlider.vue?vue&type=template&id=6309b725&scoped=true&"
import script from "./FlickingSlider.vue?vue&type=script&lang=ts&"
export * from "./FlickingSlider.vue?vue&type=script&lang=ts&"
import style0 from "./FlickingSlider.vue?vue&type=style&index=0&id=6309b725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309b725",
  null
  
)

export default component.exports